export default typeof window !== 'undefined'
  ? window.atob.bind(window)
  : str => Buffer.from(str, 'base64').toString('utf8');
